import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import isEmpty from "modules/storyblok/adapters/RichtextAdapter/utils/isEmpty";
import {
  ChakraAccordionItem as AccordionItem,
  ChakraAccordionButton as AccordionButton,
  ChakraFlex as Flex,
  ChakraAccordionIcon as AccordionIcon,
  ChakraAccordionPanel as AccordionPanel,
  ChakraAccordion,
} from "@airhelp/react-ui-components";
import { accordionHeaderStyles, accordionContentStyles } from "./Accordion.styles";
import type { AccordionProps } from "./Accordion.d";

const Accordion = ({
  items,
  icons: { close, open } = {
    close: <AccordionIcon color="primary.500" />,
    open: <AccordionIcon color="primary.500" />,
  },
  variant = "primary",
}: AccordionProps) => {
  const accordionItems =
    items &&
    items.map((item) => (
      <AccordionItem key={item._uid} boxShadow="none">
        {({ isExpanded }) =>
          !isEmpty(item.header) && (
            <>
              <AccordionButton>
                <Flex justify="space-between" textAlign="left" align={{ mobile: "flex-start", lg: "center" }} w="full">
                  <RichtextAdapter content={item.header} customStyles={accordionHeaderStyles} />
                  {isExpanded ? close : open}
                </Flex>
              </AccordionButton>
              <AccordionPanel>
                <RichtextAdapter content={item.body} customStyles={accordionContentStyles} />
              </AccordionPanel>
            </>
          )
        }
      </AccordionItem>
    ));

  return (
    <ChakraAccordion variant={variant} allowToggle>
      {accordionItems}
    </ChakraAccordion>
  );
};

export default Accordion;
